import React from "react";
import { getLanguageMeta } from "./CampaignWizard.constants";

const LanguageCards = ({ languages, selectedValue, onSelect }) => {
  return (
    <div className="llm-cards">
      {languages.map((lang) => {
        const meta = getLanguageMeta(lang.value, lang.label);
        const isSelected = selectedValue === lang.value;

        return (
          <div
            key={lang.value}
            className={`llm-card ${isSelected ? "selected" : ""}`}
            style={
              isSelected
                ? {
                    borderColor: meta.color,
                    background: `${meta.color}0d`,
                  }
                : {}
            }
            onClick={() => onSelect(lang)}
          >
            <div
              style={{
                fontSize: 28,
                marginBottom: 6,
                lineHeight: 1,
              }}
            >
              {meta.icon}
            </div>

            <div
              className="llm-card-name"
              style={isSelected ? { color: meta.color } : {}}
            >
              {lang.label}
            </div>

            <div className="llm-card-desc">{meta.desc}</div>
          </div>
        );
      })}
    </div>
  );
};

export default LanguageCards;
